module.exports = __webpack_public_path__ + "img/1 (43).53ed4e38.png";